// extracted by css-extract-rspack-plugin
export default {"badge":"badge-module__badge___ub0fe"};